/* eslint-disable no-console */
import { IS_LOCAL } from "../config";

/**
 * local development destination: logs what every other destination would
 * receive, so instrumentation can be checked without any third-party tool
 */
const consoleDestination = {
  name: "console",
  preference: "analytics",
  // mirrors every catalogued event, regardless of its `destinations` list
  receivesAllEvents: true,
  enabled: () => IS_LOCAL,
  init: () => {},
  track: (name, props, event) =>
    console.log("[analytics] track", name, props, "→", event.destinations),
  identify: (userId, traits) =>
    console.log("[analytics] identify", userId, traits),
  reset: () => console.log("[analytics] reset"),
  page: props => console.log("[analytics] page", props)
};

export default consoleDestination;
